import { motion } from 'framer-motion';

export function TestimonialsSection() {
  const testimonials = [
    {
      rating: 5,
      title: '진짜 제주를 경험했어요!',
      content: '로컬 전문가님이 추천해주신 숨은 명소들이 정말 최고였어요. 관광지가 아닌 진짜 제주를 느낄 수 있었습니다. 맞춤형 일정 덕분에 우리 가족만의 특별한 추억을 만들었어요.',
      name: '김민지',
      date: '2024년 12월',
      avatar: 'https://public.readdy.ai/ai/img_res/78508ee187978fe8e081ae372ffd05db.jpg'
    },
    {
      rating: 5,
      title: '웨딩 스냅 촬영 완벽했습니다',
      content: '성산일출봋에서 웨딩 스냅을 찍었는데, 이동부터 촬영 지원까지 모든 것이 완벽했어요. 특히 일출 시간에 맞춰 정확하게 도착해주셔서 최고의 사진을 건질 수 있었습니다. 친구같은 서비스 감사합니다!',
      name: '박준호',
      date: '2024년 11월',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20man%20portrait%20with%20confident%20smile%2C%20friendly%20business%20headshot%20with%20clean%20white%20background%2C%20natural%20lighting%2C%20approachable%20appearance%2C%20simple%20minimalist%20style&width=200&height=200&seq=avatar-man-001&orientation=squarish'
    },
    {
      rating: 5,
      title: '로컬 맛집 투어 최고!',
      content: '관광객들이 모르는 진짜 제주 맛집들을 소개받았어요. 흑돼지, 해산물, 전통 시장까지 로컬만 아는 곳들이라 더 특별했습니다. 제주블리 아니면 절대 못 갔을 곳들이에요.',
      name: '이성훈',
      date: '2024년 12월',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20businessman%20portrait%20with%20warm%20smile%2C%20executive%20headshot%20with%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20and%20friendly%20appearance%2C%20simple%20minimalist%20style&width=200&height=200&seq=avatar-man-002&orientation=squarish'
    },
    {
      rating: 5,
      title: '1:1 맞춤 설계가 정말 좋았어요',
      content: '우리 가족 취향에 딱 맞는 일정을 짜주셨어요. 70대 부모님 체력도 고려해서 여유있게 일정을 조정해주시고, 편의시설 위치까지 꼼꼼하게 안내해주셔서 안심하고 여행할 수 있었습니다.',
      name: '최유진',
      date: '2024년 11월',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20woman%20portrait%20with%20gentle%20smile%2C%20friendly%20headshot%20with%20clean%20white%20background%2C%20natural%20lighting%2C%20caring%20and%20warm%20appearance%2C%20simple%20minimalist%20style&width=200&height=200&seq=avatar-woman-002&orientation=squarish'
    },
    {
      rating: 5,
      title: '한라산 등반 최고의 경험',
      content: '한라산 백록담 등반 투어를 신청했는데, 새벽 픽업부터 하산 후 온천까지 완벽한 일정이었어요. 전문 가이드님의 설명도 유익했고, 무엇보다 안전하게 등반할 수 있어서 좋았습니다.',
      name: '정민수',
      date: '2024년 10월',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20man%20portrait%20with%20bright%20smile%2C%20athletic%20and%20friendly%20headshot%20with%20clean%20white%20background%2C%20natural%20lighting%2C%20energetic%20appearance%2C%20simple%20minimalist%20style&width=200&height=200&seq=avatar-man-003&orientation=squarish'
    },
    {
      rating: 5,
      title: '재방문 의사 200%',
      content: '숨은 명소들이 정말 대박이었어요! 사진 찍기 좋은 포인트도 알려주시고, 인스타에 올릴 감성 사진이 가득해졌습니다. 친구처럼 편하게 대해주셔서 여행 내내 즐거웠어요. 다음 달에 또 예약했습니다!',
      name: '강서연',
      date: '2024년 12월',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20woman%20portrait%20with%20cheerful%20smile%2C%20friendly%20and%20youthful%20headshot%20with%20clean%20white%20background%2C%20natural%20lighting%2C%20happy%20and%20vibrant%20appearance%2C%20simple%20minimalist%20style&width=200&height=200&seq=avatar-woman-003&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 sm:py-24 md:py-28 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <div className="inline-flex items-center gap-3 bg-[#FF8E53]/10 px-6 py-3 rounded-full mb-6 sm:mb-8">
            <i className="ri-star-line text-[#FF8E53] text-lg sm:text-xl"></i>
            <span className="text-[#FF8E53] text-base sm:text-lg font-medium">고객 후기</span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 px-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            고객님들의<br />생생한 후기
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 px-4">
            재방문율 <strong className="text-[#0E7FC0]">92%</strong> · 평균 별점 <strong className="text-[#FF8E53]">4.9/5.0</strong>
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl sm:rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FF8E53] text-xl"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-3">
                {testimonial.title}
              </h3>

              {/* Content */}
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                {testimonial.content}
              </p>

              {/* User Info */}
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-bold text-[#2C2C2C] text-base">{testimonial.name}</div>
                  <div className="text-sm text-gray-500">{testimonial.date}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {[
            { number: '4.9', unit: '/5.0', label: '평균 별점', icon: 'ri-star-fill', color: 'text-[#FF8E53]' },
            { number: '92', unit: '%', label: '재방문율', icon: 'ri-repeat-line', color: 'text-[#0E7FC0]' },
            { number: '500', unit: '+', label: '누적 고객', icon: 'ri-user-heart-line', color: 'text-[#4A7C59]' },
            { number: '100', unit: '%', label: '고객 만족도', icon: 'ri-thumb-up-line', color: 'text-[#FF1493]' }
          ].map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className={`${stat.color} mb-3`}>
                <i className={`${stat.icon} text-4xl sm:text-5xl`}></i>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#2C2C2C] mb-2">
                {stat.number}<span className="text-2xl sm:text-3xl">{stat.unit}</span>
              </div>
              <div className="text-base sm:text-lg text-gray-600">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
